import { useCallback, useEffect, useRef } from 'react';
import { WritableAtom, useAtom } from 'jotai';
import Checkbox from 'components/ui/Checkbox/Checkbox';
import useRudderStackTrack from 'hooks/useRudderStackTrack';

export const renderAtomCheckbox = ({ value, label, checkedAtom }) => (
  <AtomCheckbox key={value} checkedAtom={checkedAtom} label={label} name={value} id={value} />
);

export default function AtomCheckbox({
  checkedAtom,
  ...other
}: {
  checkedAtom: WritableAtom<boolean, void>;
  label: string;
  name: string;
  id: string;
}) {
  const [checked, toggleChecked] = useAtom(checkedAtom);
  const inputRef = useRef(null);
  // eslint-disable-next-line no-return-assign
  const register = useCallback((ref) => (inputRef.current = ref), []);
  const rudderTrack = useRudderStackTrack();

  function handleClick() {
    toggleChecked();
    rudderTrack('checkbox_toggle_search', {
      value: !checked,
      label: other.label,
    });
  }

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.checked = checked;
    }
  }, [checked]);

  return <Checkbox {...other} inputRef={register} defaultChecked={checked} onChange={() => handleClick()} />;
}
